// Modul zur Erfassung von Kosten mit Pauschale
"use strict";

import CoreModels from "dias/core/models";
import foerdermoduleRegistry from "dias/foerderantrag/foerdermodule";
import controller from "./controller";
import template from "dias/kosten_finanzierung/kosten.template.jade";
import FoerderantragModels from "dias/foerderantrag/models";

import builder from "dias/standard_foerdermodule/utils/builder";


const kosten_mit_pauschale = angular.module("dias.kosten_finanzierung.modul.kosten_mit_pauschale", [
  CoreModels.name,
  foerdermoduleRegistry.name,
  FoerderantragModels.name,
]);

kosten_mit_pauschale.config(/*@ngInject*/ FoerdermoduleRegistryProvider => {
  FoerdermoduleRegistryProvider.register("kosten_mit_pauschale", "modul-kosten-mit-pauschale");
})

  .directive("modulKostenMitPauschale", builder.directive(template, controller));

export default kosten_mit_pauschale;
